import React from 'react';
import './PilotPage.css';

const PilotPage = ({ onClose }) => {
    return (

            <div className="pilotpage-container">
            {/* <button className="pilotpage-close-button" onClick={onClose}>{'\u00D7'}</button> */}
                <div className="pilotpage-content">
                    <p>ProxBots as Pilots coming soon!</p>
                </div>
            </div>

    );
};

export default PilotPage;